/* eslint-disable max-len */
import React from 'react'
// const SystemConfig = React.lazy(() => import('../pages/SystemConfiguration/index.jsx'));
// const AddAdminCorporate=React.lazy(()=>import('../pages/ManageAdminAndCoporateUser/AddAdminCoporateUser.jsx'))
// const ListAdminCorporate=React.lazy(()=>import('../pages/ManageAdminAndCoporateUser/index.jsx'))
// const AddOrganizations=React.lazy(()=>import('../pages/ManageOrganizations/AddOrganization.jsx'))
import AddAdminCorporate from '../pages/ManageAdminAndCoporateUser/AddAdminCoporateUser'
import SystemConfig from '../pages/SystemConfiguration/index'
import ListAdminCorporate from '../pages/ManageAdminAndCoporateUser/index'
import AdminSystemConfig from '../pages/AdminSysConfig'
import AddOrganizations from '../pages/ManageOrganizations/AddOrganization'
import ViewAdminCorporateUser from '../pages/ManageAdminAndCoporateUser/ViewAdminCorporateUser.jsx'
import ManageAdminActivityHistory from '../pages/ManageAdminAndCoporateUser/ManageAdminCorActivityHistory'
import Profile from '../pages/Profile'
import AddOrganizationUser from '../pages/ManageOrganizations/ManageOrganizationUser/AddOrganizationUser.jsx'
import UpdatePassword from '../pages/Profile/UpdatePassword.jsx'
import ManageOrganization from '../pages/ManageOrganizations/Index'
import ViewOrganization from '../pages/ManageOrganizations/ViewOrganization'
import UpdateOrganization from '../pages/ManageOrganizations/UpdateOrganization'
import ManageOrganizationActivityHistory from '../pages/ManageOrganizations/ManageOrganizationActivityHistory/index.jsx'
import ManageOrganizationUser from '../pages/ManageOrganizations/ManageOrganizationUser/index.jsx'

import ManageProviders from '../pages/ManageProvider/index.jsx'
import ViewProvider from '../pages/ManageProvider/ViewProvider.jsx'
import AddProvider from '../pages/ManageProvider/AddProvider.jsx'
import ViewOrganizationUser from '../pages/ManageOrganizations/ManageOrganizationUser/ViewOrganizationUser/index.jsx'
import ManageDeviceTemplates from '../pages/ManageDeviceTemplates/index.jsx'
import AddDeviceTemplate from '../pages/ManageDeviceTemplates/AddDeviceTemplate.jsx'
import ManageProvderActivityHistory from '../pages/ManageProvider/Components/ManageProviderActivityHistory/index.jsx'
import ManageProvderExportHistory from '../pages/ManageProvider/Components/ManageProviderExportHistory/index.jsx'
import ViewDeviceTemplate from '../pages/ManageDeviceTemplates/ViewDeviceTemplate.jsx'
import AddMonitorUser from '../pages/ManageMonitorUser/addMonitorUser.jsx'
import ManageMonitorUser from '../pages/ManageMonitorUser/index.jsx'
import ManageDevice from '../pages/ManageDevice/index.jsx'
import AddDevice from '../pages/ManageDevice/AddDevice.jsx'
import ViewDevice from '../pages/ManageDevice/ViewDevice.jsx'
import ViewMonitorUsr from '../pages/ManageMonitorUser/viewMonitorUser/index.jsx'
import EditOrganizationUser from '../pages/ManageOrganizations/ManageOrganizationUser/EditOrganizationUser/index.jsx'
import ManageMonitoringConditionTemplates from '../pages/ManageMonitoringConditionsTemplates/index.jsx'
import ViewMonitorConditionTemplate from '../pages/ManageMonitoringConditionsTemplates/viewMonitotingTemplate.jsx'
import ManageOrganizationExportHistory from '../pages/ManageOrganizations/ManageOrganizationActivityHistory/ManageExportHistory/Index.jsx'

import ManagePatients from '../pages/ManagePatient/index.jsx'
import PatientIndex from '../pages/ManagePatient/AddPatient/index.jsx'
import ManageMonitorActivityHistory from '../pages/ManageMonitorUser/ManageMonitorActivityHistory/index.jsx'
import ManageMonitorExportHistory from '../pages/ManageMonitorUser/ManageMonitorActivityHistory/ManageMonitorExportHistory/Index.jsx'
import ManageOrganizationUserActivityHistory from '../pages/ManageOrganizations/ManageOrganizationUser/ManageExportHistory/index.jsx'
import ManageOrgUserExportHistory from '../pages/ManageOrganizations/ManageOrganizationUser/ManageUserExportHistory/Index.jsx'
import AddObserverDetails from '../pages/ManageObserver/AddObserver.jsx'
import ManageObserver from '../pages/ManageObserver/index.jsx'
import ViewObserver from '../pages/ManageObserver/ViewObserver.jsx'
import AddManageMonitoringCondTemplateIndex from '../pages/ManageMonitoringConditionsTemplates/addTemplateIndex.jsx'
import ManageObserverActivityHistory from '../pages/ManageObserver/Components/ManageObserverActivityHistory/Index.jsx'
import ViewPatient from '../pages/ManagePatient/ViewPatient/index.jsx'
import ManageOrgListMonitors from '../pages/ManageOrganizations/Components/MonitorUserTable/Index.jsx'
import ManageOrgListPatients from '../pages/ManageOrganizations/Components/PatientTable/index.jsx'
import ManageOrgProvider from '../pages/ManageOrganizations/Components/ProviderTable/index.jsx'
import ManageObserverExportHistory from '../pages/ManageObserver/Components/ManageObserverActivityHistory/ManageObserverExportHistory/index.jsx'
import ManagePatientActivityHistory from '../pages/ManagePatient/Component/ManagePatientActivityHistory/Index.jsx'
import ManagePatientExportHistory from '../pages/ManagePatient/Component/ManagePatientExportHistory/Index.jsx'
import ManageAdminOrCorporateExportHistory from '../pages/ManageAdminAndCoporateUser/ManageAdminCorActivityHistory/ManageAdminOrCorporateExportHistory/index.jsx'
import ManageWellnessNotes from '../pages/ManagePatient/ViewPatient/Components/ViewContactHistory/index.jsx'
import ManagePatientVitalChangeHistory from '../pages/ManagePatient/Component/ManagePatientVitalHistory/index.jsx'
import AlertListOfPatients from '../pages/Dashboard/index.jsx'
import ViewPatientAlertMainScreen from '../pages/Dashboard/ViewPatient/index.jsx'
import BloodGlouseVitalList from '../pages/ManagePatient/ViewPatient/Components/ViewVitalHistory/index.jsx'
import AlertReport from '../pages/Reports/AlertReport/index.jsx'
import ManageWellnessReports from '../pages/Reports/WellnessReports/index.jsx'
import ManageImport from '../pages/ManageImport/index.jsx'
import ManageActivityHistory from '../pages/ManageActivityHistory/index.jsx'
import ManageActivityExportHistory from '../pages/ManageActivityHistory/Components/ManageActivityExportHistory/index.jsx'
import ManageAccessLogs from '../pages/ManageAccessLogs/index.jsx'
import ManageTransferFile from '../pages/ManageTransferFile/index.jsx'


export const  ComponentsBasedOnRole ={
    "super-admin":
    [
        {
            name  : 'Profile',
            element: <Profile/>,
            path : '/profile',
            roleKey : 'Profile'
        },
        {
            name  : 'SystemConfig',
            element: <SystemConfig />,
            path : '/',
            roleKey : 'System Configuration'
        },
        {
            name  : 'SystemConfig',
            element: <SystemConfig />,
            path : '/system-configuration',
            roleKey : 'System Configuration'
        },
        {
            name  : 'Manage Admin/Corporate',
            element: <AddAdminCorporate/>,
            path : '/manage-admin-corporate/add-admin-corporate',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name  : 'Manage Admin/Corporate',
            element:<ListAdminCorporate/>,
            path : '/manage-admin-corporate',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name  : 'Manage Admin/Corporate',
            element: <AddAdminCorporate edit/>,
            path : '/manage-admin-corporate/add-admin-corporate/:id',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name:'Manage Admin/Corporate',
            element:<ViewAdminCorporateUser/>,
            path:'/manage-admin-corporate/:id',
            roleKey : 'Manage-admin-corporate'

        },
        {
            name:'Manage Admin/Corporate',
            element:<ManageAdminActivityHistory/>,
            path:'/manage-admin-corporate/activity_history',
            roleKey : 'Manage-admin-corporate'

        },
        {
            name  : 'Manage Organizations',
            element: <AddOrganizations/>,
            path : '/manage-organizations/add-organization',
            roleKey : 'Manage-organizations'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrganization/>,
            path : '/manage-organizations',
            roleKey : 'Manage-organizations'
        },
        {
            name:'Manage Organizations',
            element:<ViewOrganization/>,
            path:'/manage-organizations/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<UpdateOrganization/>,
            path:'/manage-organizations/add-organization/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<ManageOrganizationActivityHistory/>,
            path:'/manage-organizations/activity_history',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<ManageOrganizationUser/>,
            path:'/manage-organizations/manage-organization-users',
            roleKey : 'Manage-organizations'
         
        },
        {
            name:'Manage Organizations',
            element:<AddOrganizationUser/>,
            path:'/manage-organizations/manage-organization-users/add-organization-user',
            roleKey : 'Manage-organizations'
         
        },
        {
            name:'Manage Organizations',
            element:<ManageOrganizationUserActivityHistory/>,
            path:'/manage-organizations/manage-organization-user/activity_history',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<ManageOrgUserExportHistory/>,
            path:'/manage-organizations/manage-organization-user/activity_history/export-history',
            roleKey : 'Manage-organizations'

        },
        
        {
            name  : 'Manage Provider',
            element: <ManageProviders/>,
            path : '/manage-provider',
            roleKey : 'Manage-provider'
        },
        {
            name  : 'Manage Provider',
            element: <AddProvider/>,
            path : '/manage-provider/add-provider',
            roleKey : 'Manage-provider'
        },
        {
            name:'Manage Provider',
            element:<ViewProvider/>,
            path:'/manage-provider/:id',
            roleKey : 'Manage-provider'

        },
        {
            name  : 'Manage Provider',
            element: <AddProvider edit/>,
            path : '/manage-provider/add-provider/:id',
            roleKey : 'Manage-provider'
        },
        // DD team
        {
            name:'Manage Organizations',
            element:<ViewOrganizationUser/>,
            path:'manage-organizations/manage-organization-users/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name  : 'Manage Device Templates',
            element: <ManageDeviceTemplates/>,
            path : '/manage-device-templates',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate/>,
            path : '/manage-device-templates/add-device-template',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate edit/>,
            path : '/manage-device-templates/edit-device-template/:id',
            roleKey : 'Manage-device-template'
        },
        {
            name:'Manage Provider',
            element:<ManageProvderActivityHistory/>,
            path:'/manage-provider/activity_history',
            roleKey : 'Manage-provider'

        },
        {
            name:'Manage Provider',
            element:<ManageProvderExportHistory/>,
            path:'/manage-provider/activity_history/export-history',
            roleKey : 'Manage-provider'

        },
        {
            name  : 'Manage Device Templates',
            element: <ViewDeviceTemplate/>,
            path : '/manage-device-templates/:id',
            roleKey : 'Manage-device-template'
        },
        // dd team
        {
            name  : 'Manage Monitor User',
            element: <AddMonitorUser/>,
            path : '/manage-monitor-user/add-monitor-user',
            roleKey : 'Manage-monitor-user'
        },
        {
            name  : 'Manage Monitor User',
            element: <ManageMonitorUser/>,
            path : '/manage-monitor-user',
            roleKey : 'Manage-monitor-user'
        },
        {
            name:'Manage Monitor User',
            element:<ManageMonitorActivityHistory/>,
            path:'/manage-monitor-user/activity_history',
            roleKey : 'Manage-monitor-user'

        },
        {
            name:'Manage Monitor User',
            element:<ManageMonitorExportHistory/>,
            path:'/manage-monitor-user/activity_history/export-history',
            roleKey : 'Manage-monitor-user'

        },
        // Device template 
        {
            name  : 'Manage Devices',
            element: <ManageDevice/>,
            path : '/manage-devices',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <AddDevice/>,
            path : '/manage-devices/add-device',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <AddDevice edit/>,
            path : '/manage-devices/edit-device/:id',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <ViewDevice/>,
            path : '/manage-devices/:id',
            roleKey : 'Manage-devices'
        },
        // dd team
        {
            name  : 'Manage Monitor User',
            element: <AddMonitorUser edit/>,
            path : '/manage-monitor-user/add-monitor-user/:id',
            roleKey : 'Manage-monitor-user'
        },
        {
            name  : 'Manage Monitor User',
            element: <ManageMonitorUser/>,
            path : '/manage-monitor-user',
            roleKey : 'Manage-monitor-user'
        },
        {
            name:'Manage Monitor User',
            element:<ViewMonitorUsr/>,
            path:'/manage-monitor-user/:id',
            roleKey : 'Manage-monitor-user'

        },
        {
            name:'Manage Organizations',
            element:<EditOrganizationUser edit/>,
            path:'/manage-organizations/manage-organization-users/edit-organization-user/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <AddManageMonitoringCondTemplateIndex />,
            path : '/manage-monitoring-condition-templates/add-template',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        //dd
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <AddManageMonitoringCondTemplateIndex edit/>,
            path : '/manage-monitoring-condition-templates/add-template/:id',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <ManageMonitoringConditionTemplates/>,
            path : '/manage-monitoring-condition-templates',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <ViewMonitorConditionTemplate/>,
            path : '/manage-monitoring-condition-templates/:id',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrganizationExportHistory/>,
            path : '/manage-organizations/activity_history/export-history/',
            roleKey : 'Manage-organizations'
        },
        {
            name:'Manage Patients',
            element:<PatientIndex/>,
            path:'/manage-patients/add-patients',
            roleKey : 'Manage-Patients'
         
        },
        {
            name:'Manage Patients',
            element:<PatientIndex edit/>,
            path:'/manage-patients/edit-patients/:id',
            roleKey : 'Manage-Patients'
         
        },
        {
            name  : 'Manage Patients',
            element: <ManagePatientExportHistory/>,
            path : '/manage-patients/activity_history/export-history/',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatients/>,
            path:'/manage-patients',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientActivityHistory/>,
            path:'/manage-patients/activity_history',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ViewPatient/>,
            path:'/manage-patients/:id',
            roleKey : 'Manage-Patients'
         
        },
        {
            name  : 'Manage Observer',
            element: <AddObserverDetails />,
            path : '/manage-observer/add-observer',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <AddObserverDetails edit/>,
            path : '/manage-observer/edit-observer/:id',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <ManageObserver/>,
            path : '/manage-observer',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <ViewObserver/>,
            path : '/manage-observer/:id',
            roleKey : 'Manage-Observer'
        },
        {
            name:'Manage Observer',
            element:<ManageObserverActivityHistory/>,
            path:'/manage-observer/activity_history',
            roleKey : 'Manage-observer'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrgListMonitors />,
            path : '/manage-organizations/monitor-user-list/:id',
            roleKey : 'Manage-organizations'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrgListMonitors isCorp/>,
            path : '/manage-organizations/corporate-user-list/:id',
            roleKey : 'Manage-organizations'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrgListPatients/>,
            path : '/manage-organizations/patient-list/:id',
            roleKey : 'Manage-organizations'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrgProvider/>,
            path : '/manage-organizations/providers-list/:id',
            roleKey : 'Manage-organizations'
        },
        {
            name:'Manage Observer',
            element:<ManageObserverExportHistory/>,
            path:'/manage-observer/activity_history/export-history',
            roleKey : 'Manage-observer'

        },
        {
            name:'Manage Admin/Corporate',
            element:<ManageAdminOrCorporateExportHistory/>,
            path:'/manage-admin-corporate/activity_history/export-history',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name:'Manage Patients',
            element:<ManageWellnessNotes />,
            path:'/manage-patients/contact-history/:patientId',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientVitalChangeHistory/>,
            path:'/manage-patients/monitoring-condition-changes',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<BloodGlouseVitalList/>,
            path:'/manage-patients/:id/vital-history/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<BloodGlouseVitalList device/>,
            path:'/manage-patients/:id/vital-history/device/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Manage Report',
            element: <AlertReport/>,
            path : '/reports/alert-report',
            roleKey : 'Manage-report'
        },
        {
            name:'Manage Report',
            element:<ManageWellnessReports/>,
            path:'/reports/wellness-report',
            roleKey : 'Manage-report'
        },
        {
            name:'Manage Patients',
            element:<ManageImport/>,
            path:'/manage-import',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Activity History',
            element:<ManageActivityHistory/>,
            path:'/manage-activity-history',
            roleKey : 'Activity-History'
        },
        {
            name:'Activity History',
            element:<ManageActivityExportHistory/>,
            path:'/manage-activity-history/export_activity_history',
            roleKey : 'Manage-observer'

        },
        {
            name:'Access Logs',
            element:<ManageAccessLogs/>,
            path:'/manage-access-logs',
            roleKey : 'access-logs'

        },

    ],
    "admin-user":
    [
        {
            name  : 'Profile',
            element: <Profile/>,
            path : '/',
            roleKey : 'Profile'
        },
        {
            name  : 'SystemConfig',
            element: <SystemConfig />,
            path : '/system-configuration',
            roleKey : 'System Configuration'
        },
        {
            name  : 'Manage Admin/Corporate',
            element: <AddAdminCorporate/>,
            path : '/manage-admin-corporate/add-admin-corporate',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name  : 'Manage Admin/Corporate',
            element:<ListAdminCorporate/>,
            path : '/manage-admin-corporate',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name  : 'Manage Admin/Corporate',
            element: <AddAdminCorporate edit/>,
            path : '/manage-admin-corporate/add-admin-corporate/:id',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name:'Manage Admin/Corporate',
            element:<ViewAdminCorporateUser/>,
            path:'/manage-admin-corporate/:id',
            roleKey : 'Manage-admin-corporate'

        },
        {
            name:'Manage Admin/Corporate',
            element:<ManageAdminActivityHistory/>,
            path:'/manage-admin-corporate/activity_history',
            roleKey : 'Manage-admin-corporate'

        },
        {
            name  : 'Manage Organizations',
            element: <AddOrganizations/>,
            path : '/manage-organizations/add-organization',
            roleKey : 'Manage-organizations'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrganization/>,
            path : '/manage-organizations',
            roleKey : 'Manage-organizations'
        },
        {
            name:'Manage Organizations',
            element:<ViewOrganization/>,
            path:'/manage-organizations/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<UpdateOrganization/>,
            path:'/manage-organizations/add-organization/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<ManageOrganizationActivityHistory/>,
            path:'/manage-organizations/activity_history',
            roleKey : 'Manage-organizations'

        },
        {
            name  : 'Profile',
            element: <Profile/>,
            path : '/profile',
            roleKey : 'Profile'
        },
        {
            name  : 'UpdatePassword',
            element: <UpdatePassword/>,
            path : '/profile/update-password',
            roleKey : 'UpdatePassword'
        },
        {
            name  : 'Manage Provider',
            element: <ManageProviders/>,
            path : '/manage-provider',
            roleKey : 'Manage-provider'
        },
        {
            name  : 'Manage Provider',
            element: <AddProvider/>,
            path : '/manage-provider/add-provider',
            roleKey : 'Manage-provider'
        },
        {
            name:'Manage Provider',
            element:<ViewProvider/>,
            path:'/manage-provider/:id',
            roleKey : 'Manage-provider'

        },
        {
            name  : 'Manage Admin/Corporate',
            element: <AddProvider edit/>,
            path : '/manage-provider/add-provider/:id',
            roleKey : 'Manage-provider'
        },
        {
            name:'Manage Organizations',
            element:<ManageOrganizationUser/>,
            path:'/manage-organizations/manage-organization-users',
            roleKey : 'Manage-organizations'
         
        },
        {
            name:'Manage Organizations',
            element:<AddOrganizationUser/>,
            path:'/manage-organizations/manage-organization-users/add-organization-user',
            roleKey : 'Manage-organizations'
         
        },
        {
            name:'Manage Organizations',
            element:<ViewOrganizationUser/>,
            path:'manage-organizations/manage-organization-users/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<ManageOrganizationUserActivityHistory/>,
            path:'manage-organizations/manage-organization-user/activity_history',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Organizations',
            element:<ManageOrgUserExportHistory/>,
            path:'/manage-organizations/manage-organization-user/activity_history/export-history',
            roleKey : 'Manage-organizations'

        },
        {
            name:'Manage Provider',
            element:<ManageProvderActivityHistory/>,
            path:'/manage-provider/activity_history',
            roleKey : 'Manage-provider'

        },
        {
            name:'Manage Provider',
            element:<ManageProvderExportHistory/>,
            path:'/manage-provider/activity_history/export-history',
            roleKey : 'Manage-provider'

        },
        {
            name  : 'Manage Device Templates',
            element: <ViewDeviceTemplate/>,
            path : '/manage-device-templates/:id',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <ManageDeviceTemplates/>,
            path : '/manage-device-templates',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate/>,
            path : '/manage-device-templates/add-device-template',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate edit/>,
            path : '/manage-device-templates/edit-device-template/:id',
            roleKey : 'Manage-device-template'
        },
        // Device template 
        {
            name  : 'Manage Devices',
            element: <ManageDevice/>,
            path : '/manage-devices',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <AddDevice/>,
            path : '/manage-devices/add-device',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <AddDevice edit/>,
            path : '/manage-devices/edit-device/:id',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <ViewDevice/>,
            path : '/manage-devices/:id',
            roleKey : 'Manage-devices'
        },
        // dd team
        {
            name  : 'Manage Monitor User',
            element: <AddMonitorUser/>,
            path : '/manage-monitor-user/add-monitor-user',
            roleKey : 'Manage-monitor-user'
        },
        {
            name  : 'Manage Monitor User',
            element: <AddMonitorUser edit/>,
            path : '/manage-monitor-user/add-monitor-user/:id',
            roleKey : 'Manage-monitor-user'
        },
        {
            name  : 'Manage Monitor User',
            element: <ManageMonitorUser/>,
            path : '/manage-monitor-user',
            roleKey : 'Manage-monitor-user'
        },
        {
            name:'Manage Monitor User',
            element:<ViewMonitorUsr/>,
            path:'/manage-monitor-user/:id',
            roleKey : 'Manage-monitor-user'

        },
        {
            name:'Manage Monitor User',
            element:<ManageMonitorActivityHistory/>,
            path:'/manage-monitor-user/activity_history',
            roleKey : 'Manage-monitor-user'

        },
        {
            name:'Manage Monitor User',
            element:<ManageMonitorExportHistory/>,
            path:'/manage-monitor-user/activity_history/export-history',
            roleKey : 'Manage-monitor-user'

        },
        {
            name:'Manage Organizations',
            element:<EditOrganizationUser edit/>,
            path:'/manage-organizations/manage-organization-users/edit-organization-user/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrganizationExportHistory/>,
            path : '/manage-organizations/activity_history/export-history/',
            roleKey : 'Manage-organizations'
        },
        // dd team =>manage templates
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <AddManageMonitoringCondTemplateIndex/>,
            path : '/manage-monitoring-condition-templates/add-template',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        //dd
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <AddManageMonitoringCondTemplateIndex edit/>,
            path : '/manage-monitoring-condition-templates/add-template/:id',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <ManageMonitoringConditionTemplates/>,
            path : '/manage-monitoring-condition-templates',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <ViewMonitorConditionTemplate/>,
            path : '/manage-monitoring-condition-templates/:id',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name:'Manage Patients',
            element:<PatientIndex/>,
            path:'/manage-patients/add-patients',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<PatientIndex edit/>,
            path:'/manage-patients/edit-patients/:id',
            roleKey : 'Manage-Patients'
         
        },
        {
            name  : 'Manage Patients',
            element: <ManagePatientExportHistory/>,
            path : '/manage-patients/activity_history/export-history/',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientActivityHistory/>,
            path:'/manage-patients/activity_history',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatients/>,
            path:'/manage-patients',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ViewPatient/>,
            path:'/manage-patients/:id',
            roleKey : 'Manage-Patients'
         
        },
        {
            name  : 'Manage Device Templates',
            element: <ManageDeviceTemplates/>,
            path : '/manage-device-templates',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate/>,
            path : '/manage-device-templates/add-device-template',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate edit/>,
            path : '/manage-device-templates/edit-device-template/:id',
            roleKey : 'Manage-device-template'
        },
       
        {
            name  : 'Manage Observer',
            element: <AddObserverDetails/>,
            path : '/manage-observer/add-observer',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <AddObserverDetails edit/>,
            path : '/manage-observer/edit-observer/:id',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <ManageObserver/>,
            path : '/manage-observer',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <ViewObserver/>,
            path : '/manage-observer/:id',
            roleKey : 'Manage-Observer'
        },
        {
            name:'Manage Observer',
            element:<ManageObserverActivityHistory/>,
            path:'/manage-observer/activity_history',
            roleKey : 'Manage-observer'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrgListMonitors/>,
            path : '/manage-organizations/monitor-user-list/:id',
            roleKey : 'Manage-organizations'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrgListMonitors isCorp/>,
            path : '/manage-organizations/corporate-user-list/:id',
            roleKey : 'Manage-organizations'
        },
        {
            name  : 'Manage Organizations',
            element: <ManageOrgListPatients/>,
            path : '/manage-organizations/patient-list/:id',
            roleKey : 'Manage-organizations'
        },
        
        {
            name  : 'Manage Organizations',
            element: <ManageOrgProvider/>,
            path : '/manage-organizations/providers-list/:id',
            roleKey : 'Manage-organizations'
        },
        {
            name:'Manage Observer',
            element:<ManageObserverExportHistory/>,
            path:'/manage-observer/activity_history/export-history',
            roleKey : 'Manage-observer'

        },
        {
            name:'Manage Admin/Corporate',
            element:<ManageAdminOrCorporateExportHistory/>,
            path:'/manage-admin-corporate/activity_history/export-history',
            roleKey : 'Manage-admin-corporate'
        },
        {
            name:'Manage Patients',
            element:<ManageWellnessNotes />,
            path:'/manage-patients/contact-history/:patientId',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientVitalChangeHistory/>,
            path:'/manage-patients/monitoring-condition-changes',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<BloodGlouseVitalList/>,
            path:'/manage-patients/:id/vital-history/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<BloodGlouseVitalList device/>,
            path:'/manage-patients/:id/vital-history/device/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Manage Report',
            element: <AlertReport/>,
            path : '/reports/alert-report',
            roleKey : 'Manage-report'
        },
        {
            name:'Manage Report',
            element:<ManageWellnessReports/>,
            path:'/reports/wellness-report',
            roleKey : 'Manage-report'
        },
        {
            name:'Manage Patients',
            element:<ManageImport/>,
            path:'/manage-import',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Activity History',
            element:<ManageActivityHistory/>,
            path:'/manage-activity-history',
            roleKey : 'Activity-History'
        },
        {
            name:'Activity History',
            element:<ManageActivityExportHistory/>,
            path:'/manage-activity-history/export_activity_history',
            roleKey : 'Manage-observer'

        },
        {
            name  : 'Upload File',
            element: <ManageTransferFile/>,
            path : '/upload-file',
            roleKey : 'Upload-File'
        },
        {
            name:'Access Logs',
            element:<ManageAccessLogs/>,
            path:'/manage-access-logs',
            roleKey : 'access-logs'

        },

    ],
    "corporate-user":
    [
        {
            name  : 'Profile',
            element: <Profile/>,
            path : '/',
            roleKey : 'Profile'
        },
        {
            name  : 'Dashboard',
            element: <AlertListOfPatients/>,
            path : '/dashboard',
            roleKey : 'dashboard'
        },
        {
            name  : 'Dashboard',
            element: <ViewPatientAlertMainScreen/>,
            path : '/dashboard/:id/:id',
            roleKey : 'dashboard'
        },
        // {
        //     name  : 'SystemConfig',
        //     element: <SystemConfig />,
        //     path : '/system-configuration',
        //     roleKey : 'System Configuration'
        // },
        
        {
            name  : 'Manage Admin/Corporate',
            element:<ListAdminCorporate/>,
            path : '/manage-admin-corporate',
            roleKey : 'Manage-admin-corporate'
        },
       
        {
            name:'Manage Admin/Corporate',
            element:<ViewAdminCorporateUser/>,
            path:'/manage-admin-corporate/:id',
            roleKey : 'Manage-admin-corporate'

        },
        
        {
            name  : 'Profile',
            element: <Profile/>,
            path : '/profile',
            roleKey : 'Profile'
        },
        {
            name  : 'UpdatePassword',
            element: <UpdatePassword/>,
            path : '/profile/update-password',
            roleKey : 'UpdatePassword'
        },
        {
            name:'Manage Admin/Corporate',
            element:<ViewOrganization/>,
            path:'/manage-organizations/:id',
            roleKey : 'Manage-organizations'

        },
        {
            name  : 'Manage Provider',
            element: <ManageProviders/>,
            path : '/manage-provider',
            roleKey : 'Manage-provider'
        },
        {
            name  : 'Manage Provider',
            element: <AddProvider/>,
            path : '/manage-provider/add-provider',
            roleKey : 'Manage-provider'
        },
        {
            name:'Manage Provider',
            element:<ViewProvider/>,
            path:'/manage-provider/:id',
            roleKey : 'Manage-provider'

        },
        {
            name  : 'Manage Provider',
            element: <AddProvider edit/>,
            path : '/manage-provider/add-provider/:id',
            roleKey : 'Manage-provider'
        },
     
       
        // Device template 
        {
            name  : 'Manage Devices',
            element: <ManageDevice/>,
            path : '/manage-devices',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <AddDevice/>,
            path : '/manage-devices/add-device',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <AddDevice edit/>,
            path : '/manage-devices/edit-device/:id',
            roleKey : 'Manage-devices'
        },
        {
            name  : 'Manage Devices',
            element: <ViewDevice/>,
            path : '/manage-devices/:id',
            roleKey : 'Manage-devices'
        },
        // dd team =>manage templates
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <AddManageMonitoringCondTemplateIndex/>,
            path : '/manage-monitoring-condition-templates/add-template',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        //dd
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <AddManageMonitoringCondTemplateIndex edit/>,
            path : '/manage-monitoring-condition-templates/add-template/:id',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <ManageMonitoringConditionTemplates/>,
            path : '/manage-monitoring-condition-templates',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name  : 'Manage Monitoring Conditions Templates',
            element: <ViewMonitorConditionTemplate/>,
            path : '/manage-monitoring-condition-templates/:id',
            roleKey : 'Manage-monitoring-conditions-templates'
        },
        {
            name:'Manage Patients',
            element:<PatientIndex/>,
            path:'/manage-patients/add-patients',
            roleKey : 'Manage-Patients'
         
        },
        {
            name  : 'Manage Patients',
            element: <ManagePatientExportHistory/>,
            path : '/manage-patients/activity_history/export-history/',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientActivityHistory/>,
            path:'/manage-patients/activity_history',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<PatientIndex edit/>,
            path:'/manage-patients/edit-patients/:id',
            roleKey : 'Manage-Patients'
         
        },
        {
            name:'Manage Patients',
            element:<ManagePatients/>,
            path:'/manage-patients',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ViewPatient/>,
            path:'/manage-patients/:id',
            roleKey : 'Manage-Patients'
         
        },
        {
            name:'Manage Patients',
            element:<BloodGlouseVitalList/>,
            path:'/manage-patients/:id/vital-history/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<BloodGlouseVitalList device/>,
            path:'/manage-patients/:id/vital-history/device/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Manage Device Templates',
            element: <ManageDeviceTemplates/>,
            path : '/manage-device-templates',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate/>,
            path : '/manage-device-templates/add-device-template',
            roleKey : 'Manage-device-template'
        },
        {
            name  : 'Manage Device Templates',
            element: <AddDeviceTemplate edit/>,
            path : '/manage-device-templates/edit-device-template/:id',
            roleKey : 'Manage-device-template'
        },
       
        {
            name  : 'Manage Observer',
            element: <AddObserverDetails/>,
            path : '/manage-observer/add-observer',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <AddObserverDetails edit/>,
            path : '/manage-observer/edit-observer/:id',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <ManageObserver/>,
            path : '/manage-observer',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Observer',
            element: <ViewObserver/>,
            path : '/manage-observer/:id',
            roleKey : 'Manage-Observer'
        },
        {
            name  : 'Manage Device Templates',
            element: <ViewDeviceTemplate/>,
            path : '/manage-device-templates/:id',
            roleKey : 'Manage-device-template'
        },
        {
            name:'Manage Patients',
            element:<ManageWellnessNotes />,
            path:'/manage-patients/contact-history/:patientId',
            roleKey : 'Manage-Patients'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientVitalChangeHistory/>,
            path:'/manage-patients/monitoring-condition-changes',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Manage Report',
            element: <AlertReport/>,
            path : '/reports/alert-report',
            roleKey : 'Manage-report'
        },
        {
            name:'Manage Report',
            element:<ManageWellnessReports/>,
            path:'/reports/wellness-report',
            roleKey : 'Manage-report'
        },
        {
            name:'Manage Patients',
            element:<ManageImport/>,
            path:'/manage-import',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Upload File',
            element: <ManageTransferFile/>,
            path : '/upload-file',
            roleKey : 'Upload-File'
        },
  
    ]
   
}